export default "__VITE_ASSET__DAklg$OP__"